module.exports = __webpack_public_path__ + "img/edit_1.41a236e2.svg";